var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecurity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 105.49 105.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .security-cls-1 {\n        fill: #39fdc1;\n      }\n\n      .security-cls-2 {\n        fill: none;\n        stroke: #fff;\n        stroke-miterlimit: 10;\n        stroke-width: 6px;\n      }\n\n      .security-cls-3 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Defense_Button_Slider",
    "data-name": "Defense Button Slider"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "security-cls-1",
    cx: 52.74,
    cy: 52.74,
    r: 52.74
  }), /*#__PURE__*/React.createElement("path", {
    className: "security-cls-2",
    d: "M474.82,559.35c-14.61-5.64-29.68-13.17-29.68-13.17s-15.06,7.53-29.67,13.17c-1.41,16.47-1.51,42.83,29.67,58.36C476.33,602.18,476.23,575.82,474.82,559.35Z",
    transform: "translate(-392.4 -528.97)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "security-cls-3",
    d: "M462.13,561.35l-16.61,18.53L428.7,561.12c-2.27,1-4.62,2-7,2.91q-.1,1.61-.15,3.21l17.65,19.69-9.48,10.58a41.52,41.52,0,0,0,6.51,6.83L445.52,594l9,10a40.93,40.93,0,0,0,6.43-6.92l-9.07-10.12,16.92-18.87c0-1.35-.08-2.69-.16-4C466.4,563.15,464.23,562.25,462.13,561.35Z",
    transform: "translate(-392.4 -528.97)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/Security.c05750d0b943f2342b412bd177770b9a.svg";
export { ForwardRef as ReactComponent };